import { CoordinatesModel } from '../../general';

export interface FloorPlanGeo {
  order: string;
  latitude: number;
  longitude: number;
}

export interface RestrictedAccess {
  end: string;
  start: string;
  status: boolean;
  timeZone: string;
}

export interface ZoneDataModel {
  attribute: {
    altitude: number;
    floorHeight: number;
    maxPressure: number;
    minPressure: number;
    riskType: string;
  };
  centroid?: CoordinatesModel;
  childStatus: any[];
  destination: string;
  floorPlan: any;
  floorPlanGeo: FloorPlanGeo[];
  geoFence: {
    geometry: {
      coordinates?: CoordinatesModel[];
      center?: CoordinatesModel;
      radius?: number;
      type: string;
    };
    properties: {
      strokeColor: string;
      strokeOpacity: number;
      strokeWeight: number;
      fillOpacity: number;
      fillColor: string;
      labelColor: string;
    };
  };
  radius?: number | string;
  hierarchyId: string[];
  hierarchyName: string[];
  hierarchyNatureDescription: string[];
  level: string | number;
  name: string;
  nature: string;
  natureDescription: string;
  order: number;
  ptwParentStatus: any[];
  ptwStatus: any[];
  restrictedAccess: RestrictedAccess;
  siteId: string;
  _id: string;
  class?: string;
  createdDate?: string;
  polygonData?: [number, number][];
  usersCount?: object;
  zoneCount: { zoneCount: number };
}

export interface ZoneDetailPayloadModel {
  classType: string;
  siteId: string;
  sortBy: string;
}

export interface TabDefinition {
  id: string;
  translationKey: string;
  visible: boolean;
  permissionCheck?: () => boolean;
}
